export default "__VITE_ASSET__CajQxxXp__"